import React from 'react';
import {Chip, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import {blue} from '@mui/material/colors';

import {SHIFT_SELECTION_STATUS} from "../../domain/ShiftPlanConstants";
import {isShiftPlanAfterCurrentTime, sortEnrollmentsByPerformerNames} from "../../helpers/ShiftPlanHelper";

export default function PerformerNameChip({selectedPerformer, shiftPlan, handlePerformerChipClicked}) {

    const GENERATED_SHIFT_DARK_GOLD_COLOR = '#CC9933';
    const GENERATED_SHIFT_DARK_GOLD_BORDER_COLOR = '#996622';
    
    const PERFORMER_SELECTED_DARK_BLUE_COLOR = blue[700];

    if (selectedPerformer?.length === 0) {
        return <Typography>Select Performers</Typography>;
    }

    const gridStyle = {display: 'flex', flexWrap: 'wrap', gap: 0.5};

    const buildPerformerChipStyle = (enrollment) => {
        let backgroundColor = 'white';
        let color = 'black';
        let fontWeight = null;
        let border = `1px solid ${PERFORMER_SELECTED_DARK_BLUE_COLOR}`;

        if (enrollment.availability !== null) {
            backgroundColor = GENERATED_SHIFT_DARK_GOLD_COLOR;
            color = 'white';
            fontWeight = 'bold';
            border = enrollment.availability.hasAnyTeachingSessions ? `0.15rem solid ${GENERATED_SHIFT_DARK_GOLD_BORDER_COLOR}` : null;
        } else if (enrollment.shiftSelectionStatus === SHIFT_SELECTION_STATUS.SELECTED) {
            backgroundColor = PERFORMER_SELECTED_DARK_BLUE_COLOR;
            color = 'white';
        }

        return {margin: '0.1rem', backgroundColor, color, fontWeight, border};
    };
    
    const sortedEnrollments = sortEnrollmentsByPerformerNames(shiftPlan?.enrollments);

    return <Grid sx={gridStyle}>
        {sortedEnrollments?.map(enrollment => {

            const isPerformerChipDisabled = !isShiftPlanAfterCurrentTime(shiftPlan.start)
                        || (enrollment.availability === null && enrollment.shiftSelectionStatus === SHIFT_SELECTION_STATUS.CONFLICT);

            return <Chip
              key={enrollment.user.id}
              label={enrollment.user.displayName}
              disabled={isPerformerChipDisabled}
              onMouseDown={event => event.stopPropagation()}
              onClick={() => handlePerformerChipClicked(shiftPlan.id, enrollment, enrollment.user.id)}
              style={buildPerformerChipStyle(enrollment)}/>;
        })}
    </Grid>
};
